// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".t5b2THaaVdwtD3_ir32o.ant-tag {\n\twidth: fit-content !important;\n\tmax-width: fit-content !important;\n\tmargin: 0;\n}\n", "",{"version":3,"sources":["webpack://./client/src/components/ApprovalStateTag/ApprovalStateTag.module.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B,iCAAiC;CACjC,SAAS;AACV","sourcesContent":[".tag:global(.ant-tag) {\n\twidth: fit-content !important;\n\tmax-width: fit-content !important;\n\tmargin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag": "t5b2THaaVdwtD3_ir32o"
};
export default ___CSS_LOADER_EXPORT___;
